<app-tab-layout [loading]="loading()" [error]="error">
  @if (initialized()) {
    <app-radar-chart [data]="repData().data" [height]="320"></app-radar-chart>
  }
</app-tab-layout>
